import { type ReactNode, useCallback, useState } from 'react'
import { createPortal } from 'react-dom'

/** A hover card that follows the pointer, for charts. */
export function useTip() {
  const [tip, setTip] = useState<{ x: number; y: number; content: ReactNode } | null>(null)
  const bind = useCallback(
    (content: ReactNode) => ({
      onMouseMove: (e: React.MouseEvent) => setTip({ x: e.clientX, y: e.clientY, content }),
      onMouseLeave: () => setTip(null),
    }),
    [],
  )
  const node = tip
    ? createPortal(
        <div
          className="tip"
          style={{
            left: Math.min(window.innerWidth - 220, tip.x + 14),
            top: Math.max(8, tip.y - 12),
            transform: 'translateY(-100%)',
          }}
        >
          {tip.content}
        </div>,
        document.body,
      )
    : null
  return { bind, node }
}
